import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Notice,
  NoticeFindAllParams,
  NoticeStatus,
} from '../core/types';

@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  private readonly baseUrl = `${environment.apiHost}/notifications`;

  constructor(private httpClient: HttpClient) {}

  findAll(filter?: NoticeFindAllParams) {
    let params = new HttpParams()
      .set('pageIndex', String(filter?.pageIndex ?? 1))
      .set('pageSize', String(filter?.pageSize ?? 20));

    filter?.status?.forEach((status) => {
      params = params.append('status', status);
    });

    if (filter?.searchString) {
      params = params.set('searchString', filter.searchString);
    }

    return this.httpClient.get<PaginatedResponse<Notice>>(this.baseUrl, {
      params,
    });
  }

  getUnreadCount() {
    return this.httpClient.get<{ unread: number }>(
      `${this.baseUrl}/unread-count`
    );
  }

  setStatus(id: Notice['id'], status: NoticeStatus) {
    return this.httpClient.patch<Notice>(
      `${this.baseUrl}/${id}/${status}`,
      { id }
    );
  }

  markAllAsRead() {
    return this.httpClient.patch<{ success: boolean }>(
      `${this.baseUrl}/read-all`,
      {}
    );
  }
}
